import { connect } from 'react-redux';
import PaypalModal from 'account/components/payout/paypal_modal';
import { fetchAccountsIfNeeded } from 'common/ducks/payout';

const mapStateToProps = ({ user }) => {
  return {
    user: user.profile_data
  };
}

export default connect(mapStateToProps, {
  fetchAccounts: fetchAccountsIfNeeded
})(PaypalModal);



// WEBPACK FOOTER //
// ./account/containers/payout/paypal_modal.js